import React from 'react'

import { Typography, Paper } from '@material-ui/core'

import './styles.css'
import apolo from '../../assets/apolo.svg'

function NotFound() {
    return (
        <div className="notfound-container">
            <Paper elevation={1}>
                <div className="notfound-info">
                    <center><img id="logo-bw" src={apolo} alt="Xerlock Smart Gov"/></center>
                    <Typography align="center" variant="h1"><strong>404</strong></Typography>
                    <Typography align="center" variant="h5">Página não encontrada.</Typography>
                </div>
            </Paper>
        </div>
    )
}

export default NotFound
